export default __webpack_public_path__ + "static/media/arrow-2.7a8b4722.7a8b4722.png";